import React from "react";
import CompanyImportContent from "../content/companyImportContent";
import Layout from "../layout/Layout";

const CompanyImport = () => {
  return (
    <Layout>
      <CompanyImportContent />
    </Layout>
  );
};

export default CompanyImport;
